import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getInhousePreApprovalLoanDetails, getPreApprovalFormProgress,  getPreApprovalQuestions,  setPreApprovalEditMode,  setPreApprovedOrigin, updatePreApprovalLoan } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { startPreApprovalOnFly } from "../pre-approval-on-fly-modal/actions";
import FinancingNotFound from "./component";

const mapStateToProps = ({
    preApprovalLoan: {
        financeData,
        maxDeposit,
        preApproved,
        financeErrorResponse,
        preApprovalQuestions,
        financeQuotes,
        creditScore
    },
    user: {
        isLoggedIn,
        isUserZeroDpVariant
    },
    abExperiment: {
        preApprovalOnFlyDesktop
    } = {}
}) => ({
    financeData,
    preApproved,
    isLoggedIn,
    financeErrorResponse,
    isUserZeroDpVariant,
    maxDeposit,
    preApprovalQuestions,
    financeQuotes,
    creditScore,
    preApprovalOnFlyDesktop
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setPreApprovedOriginConnect: setPreApprovedOrigin,
    setPreApprovalEditModeConnect: setPreApprovalEditMode,
    getPreApprovalQuestionsConnect: getPreApprovalQuestions,
    getPreApprovalFormProgressConnect: getPreApprovalFormProgress,
    updatePreApprovalLoanConnect: updatePreApprovalLoan,
    getPreApprovalLoanDetailsConnect: getInhousePreApprovalLoanDetails,
    startPreApprovalOnFlyConnect: startPreApprovalOnFly
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FinancingNotFound);
